import React from 'react';
import { cn } from '../../../lib/utils';
import type { ProfileChipModel } from './types';

export interface ProfileChipProps {
  chip: ProfileChipModel;
  selected: boolean;
  onToggle: (id: string) => void;
  className?: string;
}

export function ProfileChip({ chip, selected, onToggle, className }: ProfileChipProps) {
  const isHollow = chip.status === 'hollow';

  const borderClass = isHollow
    ? 'border-[var(--color-border-sub)]'
    : 'border-[var(--color-border)]';

  const selectedBorderClass = selected ? 'border-[var(--color-needs-human-tint-bd)]' : '';
  const selectedFillClass = selected ? 'bg-[var(--color-needs-human-tint)]' : 'bg-transparent';
  const selectedTextClass = selected ? 'text-[var(--color-needs-human-text)]' : '';

  const baseTextClass = isHollow
    ? 'text-[var(--color-text-dim)]'
    : 'text-[var(--color-text-secondary)]';

  const hoverClass = !selected ? 'hover:bg-[var(--color-bg-hover)]' : '';

  let suffix: React.ReactNode = null;
  if (chip.status === 'flagged' && chip.flagCount && chip.flagCount > 0) {
    suffix = <span className="text-[var(--color-blocker)]">▪{chip.flagCount}</span>;
  } else if (chip.status === 'attested') {
    suffix = <span className="text-[var(--color-verified)]">✓</span>;
  } else if (chip.status === 'hollow') {
    suffix = <span className="text-[var(--color-text-ghost)]">–</span>;
  }

  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={() => onToggle(chip.id)}
      className={cn(
        'inline-flex items-center h-[20px] px-2 gap-[6px] rounded-[2px] border font-mono text-[10px] uppercase tracking-[0.08em] transition-colors duration-150',
        borderClass,
        selectedBorderClass,
        selectedFillClass,
        baseTextClass,
        selectedTextClass,
        hoverClass,
        className
      )}
    >
      <span>{chip.label}</span>
      {suffix}
    </button>
  );
}

export default ProfileChip;
